function parseError(error) {
  console.log('Error reached:', error);
  if (error?.response?.data?.error?.message)
    return { code: error?.response?.data?.error?.code, message: error?.response?.data?.error?.message };
  if (error.name === 'AxiosError')
    return { code: toCamelCase(error.code), message: error.message };

  return error;
}

function toCamelCase(str) {
  return str
    .split('_')
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join('');
}

function toSnakeCase(str) {
  return str
    .split(/(?=[A-Z])/)
    .join('_')
    .toUpperCase();
}

function toTitleCase(str) {
  return str
    .split(/(?=[A-Z])/)
    .join(' ')
    .toUpperCase();
}

function toSentenceCase(str) {
  return str
    .split(/(?=[A-Z])/)
    .join(' ')
    .toLowerCase();
}

export {
  parseError,
  toCamelCase,
  toSnakeCase,
  toTitleCase,
  toSentenceCase
};